export default {
  MuiToggleButtonGroup: {
    groupedHorizontal: {
      '&:not(:first-child)': {
        borderTopLeftRadius: '5px',
        borderBottomLeftRadius: '5px',
        borderTopRightRadius: '5px',
        borderBottomRightRadius: '5px',
        borderLeft: null,
        marginLeft: null,
      },
      '&:not(:last-child)': {
        borderTopLeftRadius: '5px',
        borderBottomLeftRadius: '5px',
        borderTopRightRadius: '5px',
        borderBottomRightRadius: '5px',
        borderLeft: null,
        marginLeft: null,
      },
    },
  },
};
